import type { ElementDisponibleType } from '@/types';

export const RELANCE_MAIL_ELEMENTS_DISPONIBLES: ElementDisponibleType[] = [
  {
    libelle: 'Civilité du payeur',
    valeur: '{Civilite_payeur}',
    icon: 'VenusAndMars',
  },
  {
    libelle: 'Nom du payeur',
    valeur: '{Nom_payeur}',
    icon: 'User',
  },
  {
    libelle: 'Date du jour',
    valeur: '{Date_du_jour}',
    icon: 'Calendar',
  },
  {
    libelle: 'Montant total des impayés',
    valeur: '{Montant_total}',
    icon: 'Euro',
  },
  {
    libelle: 'Nom de la régie',
    valeur: '{Nom_regie}',
    icon: 'Building',
  },
  {
    libelle: 'Adresse de la régie',
    valeur: '{Adresse_regie}',
    icon: 'MapPin',
  },
  {
    libelle: 'Téléphone de la régie',
    valeur: '{Telephone_regie}',
    icon: 'Phone',
  },
  {
    libelle: 'Courriel de la régie',
    valeur: '{Courriel_regie}',
    icon: 'Mail',
  },
  {
    libelle: "Horaires d'ouverture",
    valeur: '{Horaires_ouverture}',
    icon: 'Clock',
  },
  {
    libelle: 'Nom du régisseur',
    valeur: '{Nom_regisseur}',
    icon: 'UserCheck',
  },
  {
    libelle: 'Type de régisseur',
    valeur: '{Type_regisseur}',
    icon: 'BadgeCheck',
  },
];

// Éléments insérables du mail de relance AVANT date limite de paiement.
// Identique à RELANCE_MAIL_ELEMENTS_DISPONIBLES, hormis le libellé du montant
// (« Montant total dû » au lieu de « Montant total des impayés »).
export const RELANCE_AVANT_ECHEANCE_MAIL_ELEMENTS_DISPONIBLES: ElementDisponibleType[] =
  RELANCE_MAIL_ELEMENTS_DISPONIBLES.map((element) =>
    element.valeur === '{Montant_total}' ? { ...element, libelle: 'Montant total dû' } : element,
  );
